export default __webpack_public_path__ + "static/media/TXUI_Foundation_Corner_8x2.256.8a86656b.png";